/* ──────────────────────────────────────────────────────────────────
 * מודול התוספות בדף המוצר — חישוב חי והוספה לסל.
 *
 * שני דברים שנקבעו כאן בכוונה:
 *
 * 1. הכפתור מוסיף את המוצר *וגם* את התוספות, אבל את המוצר רק אם הוא לא
 *    כבר בסל. הגרסה הפשוטה — להוסיף תמיד — נותנת כמות 2 של טלפון למי
 *    שלחץ קודם על הכפתור הראשי, וזו תקלה שהלקוח מגלה רק בסל. לכן יש
 *    קריאת ‎/cart.js‎ לפני ההוספה.
 *
 * 2. ההוספה היא קריאה אחת עם ‎items[]‎, לא קריאה לפריט. זה מה שהתבנית
 *    עצמה עושה ב-‎nov.addAllToCart‎, וזה גם אטומי: או שהכל נכנס או
 *    ששום דבר לא נכנס וההודעה אחת.
 *
 * הרענון אחרי ההוספה נשען על ‎nov.initMiniCart‎ של התבנית ולא על
 * ‎location.reload‎, כדי שהמגירה תיפתח על אותו מצב גלילה.
 * ────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var SELECTOR = '[data-jm-addons]';

  function routerPrefix() {
    var root = window.routes && window.routes.root_url ? window.routes.root_url : window.router || '';
    if (root === '/') return '';
    if (typeof root === 'string' && root.slice(-1) === '/') return root.slice(0, -1);
    return root || '';
  }

  /* ‎Shopify.formatMoney‎ מגיע מ-api.jquery.js ומכבד את פורמט הכסף של
   * החנות. אם הוא לא נטען, ‎Intl‎ עם ILS נותן את אותו סימן מטבע. */
  function money(cents) {
    var amount = Number(cents) || 0;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.moneyFormat) || undefined;
      try {
        return window.Shopify.formatMoney(amount, format);
      } catch (error) {
        /* נפילה לפורמט המקומי */
      }
    }
    try {
      return new Intl.NumberFormat('he-IL', {
        style: 'currency',
        currency: 'ILS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(amount / 100);
    } catch (error) {
      return (amount / 100).toFixed(2) + ' ₪';
    }
  }

  function strings() {
    var s = (window.theme && window.theme.strings) || {};
    return {
      idle: s.addons_cta_idle || 'בחרו תוספות',
      active: s.addons_cta_active || 'הוספת המוצר והתוספות לסל',
      busy: s.addons_cta_busy || 'מוסיף…',
      error: s.addons_error || 'לא הצלחנו להוסיף לסל. נסו שוב.',
      saving: s.addons_total_save || 'חיסכון של {{ amount }}'
    };
  }

  function setup(root) {
    if (root.dataset.jmAddonsReady === 'true') return;
    root.dataset.jmAddonsReady = 'true';

    var text = strings();
    var baseEl = root.querySelector('[data-jm-addons-base]');
    var extrasEl = root.querySelector('[data-jm-addons-extras]');
    var grandEl = root.querySelector('[data-jm-addons-grand]');
    var summary = root.querySelector('[data-jm-addons-summary]');
    var savingEl = root.querySelector('[data-jm-addons-saving]');
    var submit = root.querySelector('[data-jm-addons-submit]');
    var label = root.querySelector('[data-jm-addons-cta-label]');
    var errorEl = root.querySelector('[data-jm-addons-error]');

    if (!submit) return;

    /* מחיר המוצר עצמו נקרא מחדש בכל חישוב, כי בחירת ווריאנט בדף משנה
     * אותו. ‎data-jm-base-price‎ הוא רק ערך הפתיחה. */
    function basePrice() {
      var picked = document.querySelector('[name="id"]:checked, select[name="id"], input[name="id"]');
      var fromForm = null;
      if (picked && picked.value) {
        var option = picked.tagName === 'SELECT' ? picked.selectedOptions[0] : picked;
        if (option && option.dataset && option.dataset.jmVariantPrice) {
          fromForm = Number(option.dataset.jmVariantPrice);
        }
      }
      if (fromForm !== null && !isNaN(fromForm)) return fromForm;
      return Number(root.dataset.jmBasePrice) || 0;
    }

    function mainVariantId() {
      var field = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (field && field.value) return String(field.value);
      return '';
    }

    function addonPrice(box) {
      var select = root.querySelector('[data-jm-addon-variant-select="' + box.id + '"]');
      if (select && select.selectedOptions[0]) {
        var fromOption = Number(select.selectedOptions[0].dataset.jmAddonOptionPrice);
        if (!isNaN(fromOption)) return fromOption;
      }
      return Number(box.dataset.jmAddonPrice) || 0;
    }

    function addonVariantId(box) {
      var select = root.querySelector('[data-jm-addon-variant-select="' + box.id + '"]');
      if (select && select.value) return String(select.value);
      return String(box.dataset.jmAddonVariant || '');
    }

    function checked() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-jm-addon]')).filter(function (box) {
        return box.checked;
      });
    }

    function recalc() {
      var picked = checked();
      var extras = picked.reduce(function (sum, box) {
        return sum + addonPrice(box);
      }, 0);
      var base = basePrice();

      /* החיסכון נספר רק מ-compare_at_price אמיתי שגדול מהמחיר בפועל.
       * אין כאן אחוז מומצא ואין מחיר עוגן שלא קיים בשופיפיי. */
      var saving = picked.reduce(function (sum, box) {
        var was = Number(box.dataset.jmAddonCompare) || 0;
        var now = addonPrice(box);
        return was > now ? sum + (was - now) : sum;
      }, 0);

      if (summary) {
        summary.setAttribute('data-jm-has-saving', saving > 0 ? 'true' : 'false');
      }
      if (savingEl) {
        savingEl.textContent = saving > 0 ? text.saving.replace('{{ amount }}', money(saving)) : '';
      }

      if (baseEl) baseEl.textContent = money(base);
      if (extrasEl) extrasEl.textContent = money(extras);
      if (grandEl) grandEl.textContent = money(base + extras);

      submit.disabled = picked.length === 0;
      if (label) {
        label.textContent = picked.length === 0 ? text.idle : text.active + ' (' + picked.length + ')';
      }
      hideError();
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    /* מחזיר את הכמות של הווריאנט בסל, 0 אם אינו שם. נכשל בשקט: אם
     * ‎/cart.js‎ לא זמין, עדיף לא להוסיף את המוצר הראשי מאשר להוסיף
     * אותו פעמיים. */
    function mainAlreadyInCart(variantId) {
      if (!variantId) return Promise.resolve(true);
      return fetch(routerPrefix() + '/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart unavailable');
          return response.json();
        })
        .then(function (cart) {
          return (cart.items || []).some(function (line) {
            return String(line.variant_id) === String(variantId);
          });
        })
        .catch(function () {
          return true;
        });
    }

    function refreshCart() {
      if (window.nov && typeof window.nov.initMiniCart === 'function') {
        window.nov.initMiniCart();
      }
      var status = window.theme && window.theme.cart_status;
      if (status === 'show_minicart') {
        window.setTimeout(function () {
          var drawer = document.getElementById('desktop_cart');
          if (drawer) drawer.classList.add('active');
          document.querySelectorAll('.sidebar-overlay').forEach(function (node) {
            node.classList.add('act');
          });
        }, 400);
      }
    }

    submit.addEventListener('click', function () {
      var picked = checked();
      if (picked.length === 0) return;

      var items = picked.map(function (box) {
        return { id: addonVariantId(box), quantity: 1 };
      });

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      if (label) label.textContent = text.busy;
      hideError();

      var mainId = mainVariantId();

      mainAlreadyInCart(mainId)
        .then(function (present) {
          if (!present && mainId) {
            items.unshift({ id: mainId, quantity: 1 });
          }
          return fetch(routerPrefix() + '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response
              .json()
              .catch(function () {
                return null;
              })
              .then(function (payload) {
                throw new Error((payload && payload.description) || text.error);
              });
          }
          return response.json();
        })
        .then(function () {
          root.querySelectorAll('[data-jm-addon]').forEach(function (box) {
            box.checked = false;
          });
          refreshCart();
        })
        .catch(function (error) {
          showError(error && error.message ? error.message : text.error);
        })
        .then(function () {
          submit.removeAttribute('aria-busy');
          recalc();
        });
    });

    /* ── גלולות הקטגוריה ──
     * דפוס tablist סטנדרטי: רק הגלולה הפעילה נמצאת בסדר ה-Tab, והחצים
     * מזיזים ביניהן. בלי זה Tab היה עובר על כל גלולה לפני שהוא מגיע
     * לאריח הראשון, וזה בדיוק מה שהופך רצועת סינון למכשול במקלדת. */
    var tablist = root.querySelector('[data-jm-addons-tablist]');
    if (tablist) {
      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[data-jm-addons-tab]'));

      var activate = function (tab, focus) {
        tabs.forEach(function (other) {
          var on = other === tab;
          other.setAttribute('aria-selected', on ? 'true' : 'false');
          other.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      };

      tablist.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-jm-addons-tab]');
        if (tab) activate(tab, false);
      });

      tablist.addEventListener('keydown', function (event) {
        var current = event.target.closest('[data-jm-addons-tab]');
        if (!current) return;
        var i = tabs.indexOf(current);
        var next = null;
        /* המסמך RTL: חץ שמאלה מתקדם, חץ ימינה חוזר. */
        if (event.key === 'ArrowLeft') next = tabs[(i + 1) % tabs.length];
        else if (event.key === 'ArrowRight') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          event.preventDefault();
          activate(next, true);
        }
      });
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-jm-addon], [data-jm-addon-variant-select]')) {
        recalc();
      }
    });

    /* בחירת ווריאנט של המוצר הראשי משנה את המחיר הבסיסי בסיכום. */
    document.addEventListener('change', function (event) {
      if (event.target.closest && event.target.closest('form[action*="/cart/add"]')) {
        window.setTimeout(recalc, 60);
      }
    });

    recalc();
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
